import React, { useCallback, useState } from "react";
import AppDataTable from "./AppDataTable";
import Icon from "@mdi/react";
import { mdiLockReset, mdiAccountCheckOutline } from "@mdi/js";
import { enableUserRol } from "../../interpreter/role";
import "./AppDataTable.css";

const isAccountDeleted = (row) => {
  const userStatus = row?.user?.status;
  const techStatus = row?.status;
  return String(userStatus) === "0" || String(techStatus) === "0";
};

export const PartnerList = ({ partners, openModal, onRefresh }) => {
  const [reactivatingId, setReactivatingId] = useState(null);

  const handleReactivate = useCallback(
    async (row) => {
      const userId = row?.user?.id ?? row?.userId;
      if (!userId) {
        alert("No se encontró el usuario asociado a este partner.");
        return;
      }
      const name = `${row.firstName || ""} ${row.lastName || ""}`.trim() || "este partner";
      if (!window.confirm(`¿Reactivar la cuenta de ${name}?`)) {
        return;
      }
      setReactivatingId(String(userId));
      try {
        const response = await enableUserRol(String(userId));
        alert(response?.message || "Cuenta reactivada.");
        onRefresh?.();
      } catch (err) {
        console.warn("Error al reactivar partner:", err);
        alert("No se pudo reactivar la cuenta. Intenta nuevamente.");
      } finally {
        setReactivatingId(null);
      }
    },
    [onRefresh]
  );

  const columns = [
    { name: "Código", selector: (row) => `00${row.id}`, sortable: true, center: true, width: "90px" },
    {
      name: "Nombre",
      selector: (row) => `${row.firstName || ""} ${row.lastName || ""}`.trim(),
      sortable: true,
      center: true,
    },
    {
      name: "Cód. registro",
      selector: (row) => row.user?.codigo ?? "N/A",
      sortable: true,
      center: true,
      width: "120px",
    },
    { name: "Email", selector: (row) => row.email ?? "N/A", sortable: true, center: true },
    {
      name: "Teléfono",
      selector: (row) => row.phoneNumber ?? "N/A",
      sortable: true,
      center: true,
      width: "130px",
    },
    {
      name: "Ciudad",
      selector: (row) => row.city?.name ?? "N/A",
      sortable: true,
      center: true,
      width: "120px",
    },
    {
      name: "Empresa",
      selector: (row) => row.partnerCompany?.name ?? "N/A",
      sortable: true,
      center: true,
      width: "140px",
    },
    {
      name: "Estado",
      cell: (row) =>
        isAccountDeleted(row) ? (
          <span className="table-badge table-badge--danger">Eliminada</span>
        ) : (
          <span className="table-badge table-badge--active">Activo</span>
        ),
      center: true,
      width: "110px",
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="table-actions table-actions--stack-sm">
          {isAccountDeleted(row) ? (
            <button
              type="button"
              onClick={() => handleReactivate(row)}
              className="table-action table-action--labeled table-action--success"
              title="Reactivar cuenta eliminada"
              disabled={reactivatingId === String(row?.user?.id ?? row?.userId)}
            >
              <Icon path={mdiAccountCheckOutline} size={0.95} />
              <span className="table-action__label">
                {reactivatingId === String(row?.user?.id ?? row?.userId)
                  ? "Reactivando..."
                  : "Reactivar"}
              </span>
            </button>
          ) : (
            <button
              type="button"
              onClick={() => openModal("reset", row)}
              className="table-action table-action--labeled table-action--danger"
              title="Restaurar contraseña"
            >
              <Icon path={mdiLockReset} size={0.95} />
              <span className="table-action__label">Restablecer</span>
            </button>
          )}
        </div>
      ),
      center: true,
      minWidth: "140px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div className="relative">
      <AppDataTable
        columns={columns}
        noDataComponent={<p className="table-empty">No hay técnicos partner.</p>}
        data={partners}
      />
    </div>
  );
};
